<template>
    <div>
        <!-- Button trigger modal -->
        <button v-if="openButton" type="button" class="btn btn-primary" @click="openModal">
            Launch demo modal
        </button>

        <div class="modal fade" :id="modalId" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            :aria-labelledby="modalId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header modal-header-blackground bg-color-primary">
                        <div class="col-md-11 mb-2">
                            <h3 class="modal-title" style="text-align: center;">
                                {{ title }}
                            </h3>
                        </div>
                        <div class="col-md-1 mb-2 position-relative">
                            <button type="button" class="btn-close" @click="closeModal" style="text-align: center; font-size: 2em;"
                                aria-label="Close"></button>
                        </div>
                    </div>

                    <div class="modal-body">
                        <slot name="body">Contenido por defecto</slot>
                    </div>

                    <div class="modal-footer text-center">
                        <slot name="footer">
                            <!-- <button type="button" class="btn btn-secondary" @click="closeModal">
                                Cerrar
                            </button> -->
                        </slot>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Modal } from 'bootstrap'; 
import $ from 'jquery';

export default {

    name: 'ModalComponent',

    props: {

        modalId: {
            type: String,
            required: true
        },

        title: {
            type: String,
            default: 'Titulo'
        },

        openButton: {
            type: Boolean,
            default: false
        },
    },

    data() {

        return {

            bootstrapModal: null,

        };
    },

    methods: {

        openModal() {

            const modal = $(`#${this.modalId}`);
            this.bootstrapModal = new Modal(modal);
            this.bootstrapModal.show();
        },

        closeModal() {

            this.bootstrapModal.hide();
            this.$emit('modalClosed');
        },
    },
};
</script>